import request from './request'
import PrivateRequest from './PrivateRequest'
import toast from 'react-hot-toast'



export const LoginRequest = (national_code, password) => {
  return request.get('sanctum/csrf-cookie').then(() => {
    return request.post('authToken', {national_code:national_code, password: password})
  })
}
export const Checkout = async () => {
  if(localStorage.getItem('token')) {
    return PrivateRequest().get('auth/check').then((res) => {
      if (res.data.status === 200) {
        return PrivateRequest().get('auth/user').then((res) => {
          return res
        })
      } else if(res.data.status === 401) {
        const statusCode = 401;
        const url = new URL(window.location.href);
        url.pathname = '/auth/login';
        url.searchParams.set('status', statusCode);
        window.location.href = url.toString();
        toast.error('ورود نامعتبر لطفا مجددا احرا هویت را انجام دهید')
        // alert('ورود نامعتبر')
      }
      else {
        // localStorage.clear()
        console.log('other status')
      }
    }).catch((err) => {
      console.log('err from auth.js',err)
      return err
    })
  }
}
export const UserInfoData =  async () => {
  console.log('storage',localStorage.getItem('token'))
  if(localStorage.getItem('token')) {
    let config = {
      headers: {
        Authorization: 'Bearer ' + localStorage.getItem('token') //the token is a variable which holds the token
      }
    }
    return await PrivateRequest().get('auth/user',config).then((res) => {
      console.log('auth user info info ',res)
      return res.data
    }).catch((err) => {
      // alert('ورود نامعتبر')
      const statusCode = 401;
      const url = new URL(window.location.href);
      url.pathname = '/auth/login';
      url.searchParams.set('status', statusCode);
      window.location.href = url.toString();
      toast.error('ورود نامعتبر لطفا مجددا احرا هویت را انجام دهید')
      console.log('err userinfo data',err)
      localStorage.clear()
      window.location.reload();
    })
  }

}

